import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import StaffForm from "./StaffForm";
import { addStaffApi } from "../../api/staffService";
import { getErrorMessage } from "../../utils/errorHandler";
const AddStaff = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const userId = location.state?.userId || localStorage.getItem("userId");
  const handleAdd = async (formData) => {
    try {
      setLoading(true);
      const response = await addStaffApi(formData);
      if (response?.success === false) {
        setIsError(true);
        setMessage(
          response?.error && Object.keys(response.error).length > 0
            ? ""
            : response?.message || "Failed to add staff",
        );
        return response;
      }
      setIsError(false);
      setTimeout(() => {
        navigate("/staff");
      }, 1200);
      return response;
    } catch (error) {
      setIsError(true);
      const responseData = error?.response?.data || {};
      setMessage(
        responseData?.error && Object.keys(responseData.error).length > 0
          ? ""
          : getErrorMessage(error),
      );
      return responseData;
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="container mt-4">
      {message && (
        <div className={`alert ${isError ? "alert-danger" : "alert-success"}`}>
          {message}
        </div>
      )}
      <StaffForm
        onSubmit={handleAdd}
        loading={loading}
        userId={userId}
      />
    </div>
  );
};
export default AddStaff;
